export default "__VITE_ASSET__BQktcSF7__"